module.exports = __webpack_public_path__ + "img/tj.980d12c9.svg";